import React, { useEffect, useState, Fragment, useRef } from "react";
import { PageHeader } from '../../../../Common';
import { WeighPointWiseDeductionReportTableContent } from "../../../Common/Table/tableContent";
import services from "../services";
import $ from "jquery";
import authService from "../../../Common/services";
import { LoadingSpinerComponent } from "../../../../Common/loader";
import { CSVLink } from "react-csv";
import { trackPromise } from "react-promise-tracker";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import FormHelperText from "@material-ui/core/FormHelperText";
import TextField from "@material-ui/core/TextField";
import Joi from "@hapi/joi";
import { WeighPointWiseDeductionReportSchemaObject } from '../WeighPointWiseDeductionReportSchema';
import { validateProperty, validate } from "../../../Common";
import tokenService from "../../../../Common/tokenDecoder";
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import _ from 'lodash';
import { saveAs } from 'file-saver';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = "BLOCKWEIGHTMENTREPORT";

export function WeighPointWiseDeductionReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [estates, setEstates] = useState([]);
    const [division, setDivision] = useState([]);
    const [field, setField] = useState([]);

    const [isTableHide, setIsTableHide] = useState(true);
    const [footerTotalRowExcel, setFooterTotalRowExcel] = useState([]);
    const [isReportButtonsEnabled, setIsReportButtonsEnabled] = useState(false);
    const [weighAvailabeDedauctionTypes, setWeighAvailabeDedauctionTypes] = useState([]);
    const [weighDedauctionTypesTable, setWeighDedauctionTypesTable] = useState([]);
    const [weighPointWiseDeductionDetails, setWeighPointWiseDeductionDetails] = useState({
        groupID: "0",
        estateID: "0",
        toDate: "",
        fromDate: "",
        divisionID: "0",
    });

    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        estate: "0",
        toDate: "",
        fromDate: "",
        division: "0",
    });

    const [csvHeaders, setCsvHeaders] = useState([]);

    const [csvData, setCsvData] = useState([]);
    const [errors, setErrors] = useState({});
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false,
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false,
    });

    const schema = Joi.object(WeighPointWiseDeductionReportSchemaObject).options({ allowUnknown: true });
    const contentRowNames = ["date", "sessionName", "job", "fieldName"];
    const [contentRowName, setContentRowName] = useState([]);
    const [reportData, setReportData] = useState([]);

    useEffect(() => {
        trackPromise(getPermissions(),
            getGroupsForDropdown()
        );
    }, []);

    useEffect(() => {
        trackPromise(
            getEstatesForDropdown()
        )
    }, [weighPointWiseDeductionDetails.groupID])

    useEffect(() => {
        trackPromise(getDivisionForDropdown())
    }, [weighPointWiseDeductionDetails.estateID]);

    useEffect(() => {
        trackPromise(getFieldForDropdown())
    }, [weighPointWiseDeductionDetails.divisionID]);

    function handleGroupChange(target) {
        validateInputs(target);

        setWeighPointWiseDeductionDetails({
            ...weighPointWiseDeductionDetails,
            groupID: target.value,
            estateID: "0",
            date: "",
            divisionID: "0",
            fieldID: "0",
            regNumber: ""
        });
    }

    function handleEstateChange(target) {
        validateInputs(target);

        setWeighPointWiseDeductionDetails({
            ...weighPointWiseDeductionDetails,
            estateID: target.value,
            date: "",
            divisionID: "0",
            fieldID: "0",
            regNumber: ""
        });
        clearTable();
    }

    function handleToDateChange(target) {
        validateInputs(target);

        setWeighPointWiseDeductionDetails({
            ...weighPointWiseDeductionDetails,
            date: target.value
        });
        clearTable();
    }

    function handleChangeCommon(target) {
        validateInputs(target);

        setWeighPointWiseDeductionDetails({
            ...weighPointWiseDeductionDetails,
            [target.name]: target.value
        });
        clearTable();
    }

    function handleChangeDivision(target) {
        validateInputs(target);

        setWeighPointWiseDeductionDetails({
            ...weighPointWiseDeductionDetails,
            divisionID: target.value,
            fieldID: "0",
            regNumber: ""
        });
        clearTable();
    }

    function validateInputs(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, WeighPointWiseDeductionReportSchemaObject);
        errorMessage
            ? (error[target.name] = errorMessage)
            : delete error[target.name];

        setErrors(error);
    }


    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWBLOCKWEIGHTMENTREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled:
                isOperationEntityFilterEnabled !== undefined,
        });
        var token = tokenService.getUserDetailsFromToken();

        setWeighPointWiseDeductionDetails({
            ...weighPointWiseDeductionDetails,
            groupID: token.groupID,
            estateID: token.operationEntityID
        });
        trackPromise(getGroupsForDropdown());
    }

    async function getGroupsForDropdown() {
        const result = await services.getAlGroupsForDropdown();
        setGroups(result);
    }

    async function getEstatesForDropdown() {
        const data = await services.getEstatesByGroupID(weighPointWiseDeductionDetails.groupID);
        setEstates(data);
    }

    async function getDivisionForDropdown() {
        const data = await services.GetDivisionByEstateID(weighPointWiseDeductionDetails.estateID);
        setDivision(data);
    }

    async function getFieldForDropdown() {
        const data = await services.GetFieldsByCollectionPoint(weighPointWiseDeductionDetails.divisionID);
        setField(data);
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(
                    <MenuItem key={key} value={key}>
                        {value}
                    </MenuItem>
                );
            }
        }
        return items;
    }

    async function handleSearch(e) {
        e.preventDefault();

        destroyDataTable();
        setIsTableHide(true);

        const errorMessages = validate(schema, weighPointWiseDeductionDetails);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        const result = await services.getReportData(weighPointWiseDeductionDetails);

        var mergedArray = [];
        var contentRowNamesArray = [];


        contentRowNamesArray.push("date");
        contentRowNamesArray.push("sessionName");
        contentRowNamesArray.push("job");
        contentRowNamesArray.push("fieldName");
        
        var csvHeaders = [
            { label: "Date", value: "date" },
            { label: "Session Name", value: "sessionName" },
            { label: "Job", value: "job" },
            { label: "Field Name", value: "fieldName" }
        ];

        var uniqDates = [];
        result.forEach(x => {
            uniqDates.push(x.deductionTypeName)
        })

        uniqDates = [...new Set(uniqDates)];
        uniqDates.forEach(x => {
            contentRowNamesArray.push(x);
            csvHeaders.push({
                label: x, value: x
            })
        });

        if (result !== null) {
            result.forEach(x => {
                x.date = x.date.split('T')[0]
            });
        }

        var formatedResult = formatResult(result)
        setContentRowName(contentRowNamesArray);
        setReportData(formatedResult);
        setCsvHeaders(csvHeaders);
        

        if (formatedResult.length != 0) {
            setIsTableHide(false);
            createDataTable();
            addSelectedSearchValues();
            setCsvData(formatedResult);
            generateCsvData(formatedResult);
        }
    }

    function generateCsvData(data) {

        var newRecord = {};
        var copyOfRecords = _.cloneDeep(data.formatedResult);

        copyOfRecords.push(newRecord);

        setCsvData(copyOfRecords);
    }

    function formatResult(data) {
        var result = [];
        var totalOfAllrecords = 0;
        var totalRow = [];

        data.forEach(x => {
            var deductionTypeName = (x.deductionTypeName);

            if (result.length === 0) {
                result.push({
                    date: x.date,
                    [deductionTypeName]: parseFloat(x.deductionAmount) === 0 ? "" : parseFloat(x.deductionAmount),
                    fieldName: x.fieldName,
                    job: x.job,
                    sessionName: x.sessionName,
                });
                totalRow.push({ name: x.deductionTypeName, value: parseFloat(x.deductionAmount).toFixed(2) });
            } else {
                var duplicateDate = result.find(y => (y.date) === (x.date) && y.job === x.job);

                if (duplicateDate) {
                    duplicateDate[deductionTypeName] = parseFloat(x.deductionAmount) === 0 ? "" : parseFloat(x.deductionAmount);
                } else {
                    result.push({
                        date: x.date,
                        [deductionTypeName]: parseFloat(x.deductionAmount) === 0 ? "" : parseFloat(x.deductionAmount),
                        fieldName: x.fieldName,
                        job: x.job,
                        sessionName: x.sessionName,
                    });
                }
            }
        });
        return result;
    }


    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, WeighPointWiseDeductionReportSchemaObject);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setWeighPointWiseDeductionDetails({
            ...weighPointWiseDeductionDetails,
            [e.target.name]: value
        })
    }

    function addSelectedSearchValues() {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[weighPointWiseDeductionDetails.groupID],
            estate: estates[weighPointWiseDeductionDetails.estateID],
            division: division[weighPointWiseDeductionDetails.divisionID],
            toDate: weighPointWiseDeductionDetails.toDate,
            fromDate: weighPointWiseDeductionDetails.fromDate,
        })
    }

    function destroyDataTable() {
        $("#blockWeighment").DataTable().destroy();
    }

    function createDataTable() {
        $('#blockWeighment').DataTable();
    }

    function createFile() {
        var settings = {
            sheetName: 'DeducionReport',
            fileName: 'Weigh Pont Wise Deduction Report',
            writeOptions: {}
        }

        xlsx(csvHeaders, csvData, settings, true)
    }


    function onCancelClick() {
        clearState();
    }

    function clearState() {
        setWeighPointWiseDeductionDetails({
            ...weighPointWiseDeductionDetails,
            date: "",
            division: "0",
            field: "0",
            regNumber: ""
        });
        setIsTableHide(true);
        setErrors("");
    }

    function clearTable() {
        setIsTableHide(true);
        setReportData([]);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">

                        <PageHeader
                            title="Weigh Point Wise Deduction Report"
                            isButtonEnable={permissionList.isAddEditEnabled}
                        />
                        <div className="card-body">
                            <form
                                onSubmit={(e) => handleSearch(e)}
                            >
                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            value={weighPointWiseDeductionDetails.groupID}
                                            disabled={!permissionList.isGroupFilterEnabled}
                                            onChange={(e) => handleGroupChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && (
                                            <FormHelperText error>{errors["groupID"]}</FormHelperText>
                                        )}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="estateID">Estate *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="estateID"
                                            id="estateID"
                                            name="estateID"
                                            value={weighPointWiseDeductionDetails.estateID}
                                            disabled={!permissionList.isOperationEntityFilterEnabled}
                                            onChange={(e) => handleEstateChange(e.target)}
                                        >
                                            <MenuItem value="0">--Select Estate--</MenuItem>
                                            {generateDropDownMenu(estates)}
                                        </Select>
                                        {errors["estateID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["estateID"]}</FormHelperText>)}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md">
                                        <InputLabel shrink id="divisionID">Division</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="divisionID"
                                            id="divisionID"
                                            name="divisionID"
                                            value={weighPointWiseDeductionDetails.divisionID}
                                            onChange={(e) => handleChangeDivision(e.target)}
                                        >
                                            <MenuItem value="0">--All Division--</MenuItem>
                                            {generateDropDownMenu(division)}
                                        </Select>
                                        {errors["divisionID"] && (<FormHelperText id="errbranchCode" className="text text-danger">{errors["divisionID"]}</FormHelperText>)}
                                    </div>
                                    <div className="col-md pb-1">
                                        <TextField
                                            id="fromDate"
                                            label="From Date *"
                                            name="fromDate"
                                            type="date"
                                            fullWidth
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>

                                    <div className="col-md pb-1">
                                        <TextField
                                            id="toDate"
                                            label="To Date *"
                                            name="toDate"
                                            type="date"
                                            fullWidth
                                            onChange={(e) => handleChange(e)}
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <input
                                        disabled={validate(schema, weighPointWiseDeductionDetails)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Search"
                                        onClick={e => trackPromise(handleSearch(e))}
                                    />

                                    <input type="reset"
                                        className="btn btn-warning pull-right"
                                        value="Cancel"
                                        onClick={onCancelClick}
                                    />
                                </div>
                            </form>
                            {isTableHide ? null :
                                <div>
                                    <div className="row">
                                        <div className="col-md-12 pt-2 pb-3">
                                            <div className="card p-2">
                                                <div className="table-responsive row-top-gap">
                                                    <table id="blockWeighment" className="display dataTable no-footer">
                                                        <thead>
                                                            <tr>
                                                                {contentRowName.map((x, index) => {
                                                                    let result = x.replace(/([A-Z])/g, " $1");
                                                                    let finalResult = result.charAt(0).toUpperCase() + result.slice(1);
                                                                    return (
                                                                        <th key={index}>{finalResult}</th>
                                                                    );
                                                                })}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <WeighPointWiseDeductionReportTableContent
                                                                data={reportData}
                                                                contentRowNames={contentRowName}
                                                                hasEdit={false}
                                                            />
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="pt-2">
                                        <input
                                            type="button"
                                            className="btn btn-primary pull-right ml-2"
                                            value="Excel"
                                            onClick={createFile}
                                        />

                                        <ReactToPrint
                                            documentTitle={"Weigh Point Wise Deduction Report"}
                                            trigger={() => <input
                                                type="submit"
                                                className="btn btn-primary pull-right ml-2"
                                                value="PDF"

                                            />}
                                            content={() => componentRef.current}
                                        />
                                    </div>
                                    <div hidden={true}>
                                        <CreatePdf ref={componentRef} reportData={reportData}
                                            rowNames={contentRowName} searchData={selectedSearchValues} />
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
